import create from 'zustand'
import store from 'store2'

const defaultInput = store.get('audioInput')
const defaultOutput = store.get('audioOutput')

export type DeviceId = string | null

// type Menu = 'main' | 'contactomat'

type State = {
  input: DeviceId
  output: DeviceId
  setInput: (id: DeviceId) => void
  setOutput: (id: DeviceId) => void
}

export const useDeviceChooserStore = create<State>(set => ({
  input: defaultInput,
  output: defaultOutput,
  setInput: (id: DeviceId) => {
    if (id) {
      store.set('audioInput', id)
    } else {
      store.remove('audioInput')
    }

    set(state => ({ input: id }))
  },
  setOutput: (id: DeviceId) => {
    if (id) {
      store.set('audioOutput', id)
    } else {
      store.remove('audioOutput')
    }

    set(state => ({ output: id }))
  },
}))
